/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  AccountState,
  ApplicationAction,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  SIGNUP_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_RESET, UPDATE_USER_AVATAR_REQUEST, UPDATE_USER_AVATAR_SUCCESS, UPDATE_USER_AVATAR_FAILURE, IMPERSONATE_LOGIN_REQUEST, IMPERSONATE_LOGIN_SUCCESS, IMPERSONATE_LOGIN_FAILURE,
} from 'store/types';
import SecureLS from 'secure-ls';
const ls = new SecureLS({ encodingType: 'aes' });
let token, user;

try {
  token = !!ls.get('token') ? ls.get('token') : undefined;
  user = !!ls.get('user') ? ls.get('user') : undefined;
} catch (error) { }


const initialState: AccountState = {
  user,
  token,
  loading: {
    login_failed: false,
    avatar_loading: false,
    login_failed_message: '',
    login_loading: false,
    signup_failed: false,
    signup_success: false,
    signup_loading: false,
    signup_failed_message: '',
    update_profile_loading: false,
    update_profile_failed: false,
    update_profile_failed_message: '',
    update_password_failed: false,
    update_password_success: false,
    update_password_loading: false,
    update_password_failed_message: '',
    update_profile_success: false
  }
};

const reducer = (state = initialState, action: ApplicationAction) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft: AccountState) => {
        // Ensure we clear current session
        draft.user = undefined;
        draft.token = undefined;
        draft.loading.login_failed = false;
        draft.loading.login_failed_message = ''
        draft.loading.login_loading = true;
        draft.loading.login_failed = false;
      });
    }
    case LOGIN_SUCCESS: {
      const { user, token } = action;

      // We don't save SafeZone token but update it in redux
      let { safe_token, ...user_to_save } = user;

      ls.set('token', token);
      ls.set('user', user_to_save);
      return produce(state, (draft) => {
        draft.user = user;
        draft.token = token;
        draft.loading.login_loading = false;
        draft.loading.login_failed = false;
        draft.loading.login_failed_message = '';
      });
    }

    case LOGIN_FAILURE: {
      const { message } = action;

      return produce(state, (draft) => {
        draft.loading.login_loading = false;
        draft.loading.login_failed = true;
        draft.loading.login_failed_message = message;
      });
    }


    //impersonate 

    case IMPERSONATE_LOGIN_REQUEST: {
      return produce(state, (draft: AccountState) => {
        // Ensure we clear current session
        draft.user = undefined;
        draft.token = undefined;
        draft.loading.login_failed = false;
        draft.loading.login_failed_message = ''
        draft.loading.login_loading = true;
        draft.loading.login_failed = false;
      });
    }
    case IMPERSONATE_LOGIN_SUCCESS: {
    const  real_user_token = ls.get('token')
    const   real_user_info = ls.get('user')
    

    ls.set('user_2',real_user_info)
    ls.set('token_2',real_user_token)


      const { user, token } = action;

      // // We don't save SafeZone token but update it in redux
       let { safe_token, ...user_to_save } = user;

      ls.set('token', token);
      ls.set('user', user_to_save);
      return produce(state, (draft) => {
        draft.user = user;
        draft.token = token;
        draft.loading.login_loading = false;
        draft.loading.login_failed = false;
        draft.loading.login_failed_message = '';
      });
      // return
    }

    case IMPERSONATE_LOGIN_FAILURE: {
      // const { message } = action;

      return produce(state, (draft) => {
        draft.loading.login_loading = false;
        draft.loading.login_failed = true;
        draft.loading.login_failed_message = "message";
      });
    }



    //register feature
    case SIGNUP_REQUEST: {
      return produce(state, (draft) => {
        draft.loading.signup_loading = true;
        draft.loading.signup_failed = false;
        draft.loading.signup_success = false;
        draft.loading.signup_failed_message = '';
      });
    }

    case SIGNUP_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading.signup_loading = false;
        draft.loading.signup_failed = false;
        draft.loading.signup_success = true;
        draft.loading.signup_failed_message = '';
      });
    }

    case SIGNUP_FAILURE: {
      const { message } = action;

      return produce(state, (draft) => {
        draft.loading.signup_loading = false;
        draft.loading.signup_failed = true;
        draft.loading.signup_success = false;
        draft.loading.signup_failed_message = message;
      });
    }

    //update password feature
    case UPDATE_PASSWORD_REQUEST: {
      return produce(state, (draft) => {
        draft.loading.update_password_loading = true;
        draft.loading.update_password_failed = false;
        draft.loading.update_password_success = false;
        draft.loading.update_password_failed_message = '';
      });
    }

    case UPDATE_PASSWORD_RESET: {
      return produce(state, (draft) => {
        draft.loading.update_password_loading = false;
        draft.loading.update_password_failed = false;
        draft.loading.update_password_success = false;
        draft.loading.update_password_failed_message = '';
      });
    }

    case UPDATE_PASSWORD_FAILURE: {
      const { message } = action;

      return produce(state, (draft) => {
        draft.loading.update_password_loading = false;
        draft.loading.update_password_failed = true;
        draft.loading.update_password_success = false;
        draft.loading.update_password_failed_message = message;
      });
    }

    case UPDATE_USER_AVATAR_REQUEST: {
      return produce(state, (draft: AccountState) => {
        // Ensure we clear current session
        draft.user = undefined;
      });
    }
    case UPDATE_USER_AVATAR_SUCCESS: {
      const { user } = action;
      ls.set('user', user);
      return produce(state, (draft) => {
        draft.user = user;
        draft.loading.avatar_loading = false;
        draft.loading.login_failed = false;
        draft.loading.login_failed_message = '';
      });
    }

    case UPDATE_USER_AVATAR_FAILURE: {
      const { message } = action;

      return produce(state, (draft) => {
        draft.loading.avatar_loading = false;
        draft.loading.login_failed = true;
        draft.loading.login_failed_message = message;
      });
    }

    case LOGOUT: {
      ls.remove('token');
      ls.remove('user');
      return produce(state, (draft) => {
        draft.user = undefined;
        draft.token = undefined;
      });
    }

    default: {
      return state;
    }
  }
};

export default reducer;
